import Immutable from 'immutable';

import { TOGGLE_BURGER } from '../actions/burger';
import { SET_SLIDER_LOCK } from '../actions/bgslider';
import { DATA_SUCCESS } from '../actions';
import {
    PONIES,
    GOTO_NAV,
    GOTO_SECTION,
    SET_LANG,
} from '../actions/navigation';

export default function luraschi(
    state = Immutable.fromJS({
      data: {},
      lang: 'fr',
      ponies: false,
      navonly: false,
      burger: { opened: false },
      slider: { locked: false },
    }), action) {
  const burgerState = state.getIn(['burger', 'opened'], false)
  switch (action.type) {
    case DATA_SUCCESS:
      return state.set('data', action.response);
    case SET_LANG:
      return state.set('lang', action.payload);

    case PONIES:
      return state.set('ponies', !state.get('ponies', false));

    case TOGGLE_BURGER:
      return state.setIn(['burger', 'opened'], !burgerState).set('navonly', !burgerState);
    case SET_SLIDER_LOCK:
      return state.setIn(['slider', 'locked'], action.payload);

    case GOTO_NAV:
      return state.set('navonly', true);
    case GOTO_SECTION:
      return state.set('navonly', false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./common/reducers/luraschi.js